import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { BankService } from 'src/app/services/bank.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { UserSaved } from 'src/app/models/user.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ToastrService } from 'ngx-toastr';
import { BankTransferAdministrativeLog } from 'src/app/models/bank-transfer-administrative-log';
import { BankTransferAdministrativeLogService } from 'src/app/services/bank-transfer-administrative-log.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-deposit-config',
  templateUrl: './deposit-config.component.html',
  styleUrls: ['./deposit-config.component.scss']
})
export class DepositConfigComponent implements OnInit {

  allCompanies: CompanyRoleResponse[] = [];
  companies: CompanyRoleResponse[] = [];
  companyId = null;
  user: UserSaved = null;

  banksCF = [];
  banksFact = [];
  accountSelectedFACT = null;
  accountSelectedCF = null;
  requestSelected = null;
  depositRequest: BankTransferAdministrativeLog[] = [];
  loading = false;
  loadingData = false;
  loadingBankFact = false;
  loadingBankCF = false;
  startDate: string = null;
  warehouses = [];
  warehousesName: { [key: number]: string } = {};
  banksCooperative = [];
  accountSelectedCooperative = null;
  loadingBankCooperative = false;
  banksAuxiliar = [];
  accountSelectedAuxiliar = null;
  loadingBankAuxiliar = false;

  constructor(
    private authService: AuthenticationService,
    private accountService: AccountService,
    private bankTransferAdministrativeLogService: BankTransferAdministrativeLogService,
    private warehouseService: WarehouseService,
  private toastService: ToastrService) {
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.user = this.authService.getUser();
    this.allCompanies = this.companies;
    this.startDate = new Date().toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    this.companyId = this.authService.getCurrentCompanyId();
    this.getWarehouses();
    this.getDepositRequests();
  }

  getWarehouses() {
      this.warehouseService.getWarehouseByClue('').subscribe({
        next: (response: ResponseObject) => {
          this.warehouses = response.data;
          this.warehouses.forEach((w) => {
            this.warehousesName[w.id] = w.name;
          });
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    }

  getBankAccount(companyId) {
    this.loadingBankFact = true;
    this.accountService.getAccountsCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.banksCF = response.data ?? [];
        this.accountSelectedCF = this.requestSelected.cfBankAccountId;
        this.loadingBankFact = false;
      },
      error: (error) => {
        this.loadingBankFact = false;
        this.toastService.error("Error al cargar las cuentas bancarias", "Error");
      }
    });
  }

  getBankAccountAuxiliar(companyId) {
    this.loadingBankAuxiliar = true;

    this.accountService.getAccountsCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.banksAuxiliar = response.data ?? [];
        this.accountSelectedAuxiliar =
          this.requestSelected.auxiliarBankAccountId;

        this.loadingBankAuxiliar = false;
      },
      error: () => {
        this.loadingBankAuxiliar = false;
        this.toastService.error(
          "Error al cargar las cuentas bancarias de auxiliar",
          "Error"
        );
      }
    });
  }

  getBankAccountInvoice(companyId) {
    this.loadingBankCF = true;
    this.accountService.getAccountsCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.banksFact = response.data ?? [];
        this.accountSelectedFACT = this.requestSelected.invoiceBankAccountId;
        this.loadingBankCF = false;
      },
      error: (error) => {
        this.toastService.error("Error al cargar las cuentas bancarias", "Error");
        this.loadingBankCF = false;
      }
    });
  }

  getBankAccountCooperative(companyId) {
    this.loadingBankCooperative = true;
    this.accountService.getAccountsCompany(companyId).subscribe({
      next: (response: ResponseObject) => {
        this.banksCooperative = response.data ?? [];
        this.accountSelectedCooperative = this.requestSelected.cooperativeBankAccountId;
        this.loadingBankCooperative = false;
      },
      error: () => {
        this.loadingBankCooperative = false;
        this.toastService.error("Error al cargar las cuentas bancarias de cooperativa", "Error");
      }
    });
  }

  getDepositRequests() {
    this.loadingData = true;
    this.bankTransferAdministrativeLogService.getDepositRequests(this.startDate).subscribe({
      next: (response: ResponseObject) => {
        this.depositRequest = response.data ?? [];
        this.loadingData = false;
      },
      error: (error) => {
        this.toastService.error("Error al cargar las solicitudes de depósito", "Error");
        this.loadingData = false;
      }
    });
  }

  setResponseSelected(request: BankTransferAdministrativeLog) {
    if (this.requestSelected != null && this.requestSelected.id == request.id) {
      this.requestSelected = null;
      this.accountSelectedCF = null;
      this.accountSelectedFACT = null;
      this.accountSelectedCooperative = null;
      this.banksCooperative = [];
      this.accountSelectedAuxiliar = null;
      this.banksAuxiliar = [];
      return;
    }

    this.requestSelected = null;
    this.accountSelectedCF = null;
    this.accountSelectedFACT = null;
    this.accountSelectedCooperative = null;
    this.banksCooperative = [];
    this.accountSelectedAuxiliar = null;
    this.banksAuxiliar = [];

    this.requestSelected = request;

    this.getBankAccount(request.cfCompanyId);
    this.getBankAccountInvoice(request.invoiceCompanyId);

    if (request.cooperativeBankAccountId != null) {
      this.getBankAccountCooperative(request.cooperativeCompanyId);
    }

    if (request.auxiliarCompanyId != null) {
      this.getBankAccountAuxiliar(request.auxiliarCompanyId);
    }
  }

  requiresCooperative(): boolean {
    return this.requestSelected?.cooperativeBankAccountId != null;
  }

  requiresAuxiliar(): boolean {
    return this.requestSelected?.auxiliarCompanyId != null;
  }

  sendResponse() {
    if (this.accountSelectedCF == null || this.accountSelectedFACT == null || this.requestSelected == null) {
      this.toastService.warning("Por favor seleccione todas las cuentas y el depósito a responder", "Advertencia");
      return;
    }

    if (this.requiresCooperative() && this.accountSelectedCooperative == null) {
      this.toastService.warning("Por favor seleccione la cuenta de cooperativa", "Advertencia");
      return;
    }
    
    if (this.requiresAuxiliar() && this.accountSelectedAuxiliar == null) {
      this.toastService.warning("Por favor seleccione la cuenta auxiliar", "Advertencia");
      return;
    }



    const data: any = {
      invoiceBankAccountId: Number(this.accountSelectedFACT),
      cfBankAccountId: Number(this.accountSelectedCF),
    };

    if (this.requiresCooperative()) {
      data.cooperativeBankAccountId = Number(this.accountSelectedCooperative);
    }

    if (this.requiresAuxiliar()) {
      data.auxiliarBankAccountId = Number(this.accountSelectedAuxiliar);
    }

    this.loading = true;
    this.bankTransferAdministrativeLogService.respondDepositRequest(data, this.requestSelected.id).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Depósito respondido exitosamente", "Éxito");
        this.loading = false;
        this.accountSelectedCF = null;
        this.accountSelectedFACT = null;
        this.accountSelectedCooperative = null;
        this.requestSelected = null;
        this.banksCooperative = [];
        this.accountSelectedAuxiliar = null;
        this.banksAuxiliar = [];
        this.getDepositRequests();
      },
      error: () => {
        this.loading = false;
        this.toastService.error("Error al responder el depósito", "Error");
      }
    });
  }

}
